module.exports = __webpack_public_path__ + "static/media/target-optical@3x.d8c868f2.png";